import {AssetPackageDto} from './asset-package.model';

export class AssetPackageSearchResultDto {
  totalResults: number;
  assetControlGroupDtoList: AssetPackageDto[];
}
